import React from 'react'
import { useContentful } from '@pcln/contentful-components'
import { useFeature } from '@pcln/feature-components'
import GenericBanner from '../../GenericBanner'
import MARKETING_TOUT from '../../../constants/promotions/marketing-tout'
import MerchModuleWrapper from '../../MerchModuleWrapper'

export default function MarketingTout() {
  const contentfulEnabled = useFeature('siteExperience.contentfulEnabled')
  const marketingTout: any = useContentful('marketingTout')
  const isContentfulEnabledAndHasContent =
    contentfulEnabled && marketingTout != null
  return isContentfulEnabledAndHasContent ? (
    <MerchModuleWrapper {...marketingTout} />
  ) : (
    <GenericBanner content={MARKETING_TOUT} />
  )
}
